import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-492106d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "beauty-business" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("textarea", { class: "beauty-business-textarea" }, "公司主要从事成套设备出口和工程承包、一般贸易、境外实业经营。成套设备出口和工程承包是公司的核心业务，业务涉及工业、交通、基建等诸多领域，业务市场主要分布在亚、非、拉等发展中国家，主要国别包括孟加拉、埃塞俄比亚、巴巴多斯、牙买加、肯尼亚、坦桑尼亚、南非、乌干达等。", -1))
const _hoisted_3 = { class: "beauty-business-bt" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 我已经阅读")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("《美居业务合作协议》")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("并同意严可先遵守其中的约定 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交申请")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("放弃")
const _hoisted_9 = ["src"]

import { ref } from 'vue'
import { Plus } from '@element-plus/icons-vue'
import type { UploadFile } from 'element-plus/es/components/upload/src/upload.type'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const dialogImageUrl = ref('')
const dialogVisible = ref(false)
const handleRemove = (file: UploadFile, fileList: UploadFile[]) => {
  console.log(file, fileList)
}
const handlePictureCardPreview = (file: UploadFile) => {
  dialogImageUrl.value = file.url!
  dialogVisible.value = true
}


return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, { "label-width": "120px" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "业务介绍" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "beauty-business-mt",
          label: "图册"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              action: "https://jsonplaceholder.typicode.com/posts/",
              "list-type": "picture-card",
              "on-preview": handlePictureCardPreview,
              "on-remove": handleRemove
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Plus))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_container, { class: "beauty-business-check" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox),
          _hoisted_4,
          _createVNode(_component_el_link, { type: "primary" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, { class: "beauty-business-btn" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "beauty-business-btn-w",
            disabled: "",
            type: "primary",
            size: "large"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "beauty-business-btn-w",
            size: "large"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          width: "100%",
          src: dialogImageUrl.value,
          alt: ""
        }, null, 8, _hoisted_9)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})